// type is either ALL, UNASSIGNED, MY_MESSAGES
// if set is true, set the new state, otherwise just return the value
// return is CustomerConversation[]

// Helper to check if a conversation is assigned to a specific user
// _assignees (array) is primary, _assignee (single) is deprecated fallback
const isAssignedToUser = (convo, userId) => {
	if (convo._assignees?.length > 0) {
		return convo._assignees.includes(userId);
	}
	// Fallback to deprecated _assignee field
	return convo._assignee === userId;
};

// Helper to check if a conversation is unassigned
const isUnassigned = (convo) => {
	const hasAssignees = convo._assignees?.length > 0;
	const hasLegacyAssignee = !!convo._assignee;
	const hasDepartment = !!convo._department;
	return !hasAssignees && !hasLegacyAssignee && !hasDepartment;
};

export const getFilteredCustomerConversationsFromSelectionState = ({
	customerConversations = [],
	assignedTypeSelected = 'ALL',
	openConversationsSelected = true,
	showOnlyUnreadConversations = false,
	_user,
}) => {
	// if TYPE === ALL, return all customer conversations. this is the default case
	let filteredCustomerConversations = customerConversations;

	// if type === UNASSIGNED only show conversations with no assignees
	if (assignedTypeSelected === 'UNASSIGNED') {
		filteredCustomerConversations = customerConversations.filter(
			(convo) => isUnassigned(convo)
		);
	} else if (assignedTypeSelected === 'MY_MESSAGES') {
		filteredCustomerConversations = customerConversations.filter(
			(convo) => isAssignedToUser(convo, _user)
		);
	} else if (assignedTypeSelected.includes('USER_')) {
		const _assignedUser = assignedTypeSelected.split('_')[1];
		filteredCustomerConversations = customerConversations.filter(
			(convo) => isAssignedToUser(convo, _assignedUser)
		);
	} else if (assignedTypeSelected.includes('TAG_')) {
		// we split by _ because we want everything after the word TAG_.
		// we join the rest of the tag together by _ because we split by _. if their original tag included key _, this will be included.
		const [, ...rest] = assignedTypeSelected.split('_');
		const tag = rest.join('_');

		filteredCustomerConversations = customerConversations.filter(
			(convo) => convo._customer?.tags?.includes(tag)
		);
	} else if (assignedTypeSelected.includes('DEPARTMENT_')) {
		const _department = assignedTypeSelected.split('_')[1];
		filteredCustomerConversations = customerConversations.filter(
			(convo) => convo._department === _department
		);
	} else if (assignedTypeSelected.includes('LOCATION_')) {
		const _location = assignedTypeSelected.split('_')[1];
		filteredCustomerConversations = customerConversations.filter(
			(convo) => convo._business === _location
		);
	} else if (assignedTypeSelected.includes('FOLDER_')) {
		const _folder = assignedTypeSelected.split('_')[1];
		filteredCustomerConversations = customerConversations.filter(
			(convo) => convo._folder === _folder
		);
	}

	if (
		!filteredCustomerConversations ||
		!filteredCustomerConversations.length
	) {
		return [];
	}

	// filter by open or closed
	filteredCustomerConversations = filteredCustomerConversations.filter(
		(convo) => convo.open === openConversationsSelected
	);

	if (showOnlyUnreadConversations) {
		filteredCustomerConversations = filteredCustomerConversations.filter(
			(convo) => !convo.isRead
		);
	}

	return filteredCustomerConversations;
};
